/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingMelcoDigitizingModelsOrderAlert
 */
export interface DigitizingMelcoDigitizingModelsOrderAlert {
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoDigitizingModelsOrderAlert
     */
    alert_id?: number;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderAlert
     */
    subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderAlert
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderAlert
     */
    alert_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderAlert
     */
    alert_submitted_by?: string | null;
}

export function DigitizingMelcoDigitizingModelsOrderAlertFromJSON(json: any): DigitizingMelcoDigitizingModelsOrderAlert {
    return DigitizingMelcoDigitizingModelsOrderAlertFromJSONTyped(json, false);
}

export function DigitizingMelcoDigitizingModelsOrderAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoDigitizingModelsOrderAlert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'alert_id': !exists(json, 'alert_id') ? undefined : json['alert_id'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'alert_type': !exists(json, 'alert_type') ? undefined : json['alert_type'],
        'alert_submitted_by': !exists(json, 'alert_submitted_by') ? undefined : json['alert_submitted_by'],
    };
}

export function DigitizingMelcoDigitizingModelsOrderAlertToJSON(value?: DigitizingMelcoDigitizingModelsOrderAlert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'alert_id': value.alert_id,
        'subject': value.subject,
        'message': value.message,
        'alert_type': value.alert_type,
        'alert_submitted_by': value.alert_submitted_by,
    };
}


